/*
 * Quick View (Vista rápida) + Quick Buy (Compra rápida)
 * Balam Denim Wear — added 10.08.26 on theme "DEVY - Vista rapida y compra rapida - 10.08.26"
 * Hotfix 10.08.26: option-group label "[object Object]" bug fixed via getOptionName().
 */
(function () {
  'use strict';

  var theme = (window.theme = window.theme || {});
  var routes = theme.routes || {};
  var CART_ADD_URL = routes.cartAdd || '/cart/add.js';
  var MONEY_FORMAT = (theme.settings && theme.settings.moneyFormat) || '${{amount}}';

  var strings = window.quickViewStrings || {};
  function t(key, fallback) {
    return strings[key] || fallback;
  }

  function formatMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      try {
        return window.formatMoney(cents, MONEY_FORMAT);
      } catch (e) {
      }
    }
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function imgUrl(url, width) {
    url = normalizeImageUrl(url);
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function truncate(str, len) {
    if (!str || str.length <= len) return str || '';
    return str.slice(0, len).replace(/\s+\S*$/, '') + '…';
  }

  function extractSentence(text, regex) {
    var match = text.match(regex);
    return match ? match[0].trim() : '';
  }

  var modalEl, bodyEl, toastEl;
  var currentProduct = null;
  var currentVariant = null;
  var currentSelections = [null, null, null];
  var currentQty = 1;
  var productCache = {};

  function ensureRefs() {
    if (!modalEl) modalEl = document.getElementById('QuickViewModal');
    if (!bodyEl) bodyEl = document.getElementById('QuickViewBody');
    if (!toastEl) toastEl = document.getElementById('QuickViewToast');
  }

  function showToast(message) {
    ensureRefs();
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._hideTimer);
    toastEl._hideTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('qvb-scroll-lock', !!lock);
  }

  function openModal() {
    ensureRefs();
    if (!modalEl) return;
    modalEl.classList.add('is-open');
    modalEl.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var closeBtn = modalEl.querySelector('.qvb-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    ensureRefs();
    if (!modalEl) return;
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      });
  }

  function isColorOptionName(name) {
    name = (name || '').toLowerCase();
    return name === 'color' || name === 'colour' || name.indexOf('color') !== -1 || name.indexOf('colour') !== -1;
  }

  function getOptionName(product, optionIndex) {
    var opt = product.options && product.options[optionIndex];
    if (opt == null) return '';
    if (typeof opt === 'string') return opt;
    if (typeof opt === 'object') return opt.name || '';
    return String(opt);
  }

  function uniqueOptionValues(product, index) {
    var seen = {};
    var out = [];
    product.variants.forEach(function (variant) {
      var val = [variant.option1, variant.option2, variant.option3][index];
      if (val && !seen[val]) {
        seen[val] = true;
        out.push(val);
      }
    });
    return out;
  }

  function variantAvailableForValue(product, index, value) {
    return product.variants.some(function (variant) {
      var vals = [variant.option1, variant.option2, variant.option3];
      return vals[index] === value && variant.available;
    });
  }

  function findMatchingVariant(product, selections) {
    return (
      product.variants.filter(function (variant) {
        var vals = [variant.option1, variant.option2, variant.option3];
        return selections.every(function (sel, i) {
          return sel == null || vals[i] === sel;
        });
      })[0] || null
    );
  }

  function buildThumbs(images) {
    if (!images || images.length < 2) return '';
    var out = '<div class="qvb-thumbs">';
    images.forEach(function (src, i) {
      out +=
        '<button type="button" class="qvb-thumb' +
        (i === 0 ? ' is-active' : '') +
        '" data-full="' +
        escapeHtml(imgUrl(src, 800)) +
        '" aria-label="' +
        t('image', 'Imagen') +
        ' ' +
        (i + 1) +
        '">' +
        '<img src="' +
        escapeHtml(imgUrl(src, 120)) +
        '" alt="" loading="lazy"></button>';
    });
    out += '</div>';
    return out;
  }

  function buildOptionPills(product, optionIndex) {
    var name = getOptionName(product, optionIndex);
    if (!name) return '';
    var values = uniqueOptionValues(product, optionIndex);
    if (values.length < 2) return '';
    var out =
      '<div class="qvb-option" data-option-index="' +
      optionIndex +
      '">' +
      '<div class="qvb-option__label">' +
      escapeHtml(name) +
      '</div>' +
      '<div class="qvb-pills">';
    values.forEach(function (value) {
      var available = variantAvailableForValue(product, optionIndex, value);
      out +=
        '<button type="button" class="qvb-pill' +
        (!available ? ' qvb-pill--disabled' : '') +
        '" data-option-index="' +
        optionIndex +
        '" data-value="' +
        escapeHtml(value) +
        '"' +
        (!available ? ' disabled' : '') +
        '>' +
        escapeHtml(value) +
        '</button>';
    });
    out += '</div></div>';
    return out;
  }

  function renderQuickView(product) {
    currentProduct = product;
    currentQty = 1;

    var optionCount = product.options ? product.options.length : 0;
    currentSelections = [null, null, null];

    currentVariant =
      product.variants.filter(function (v) {
        return v.available;
      })[0] || product.variants[0];

    for (var i = 0; i < optionCount; i++) {
      currentSelections[i] = [currentVariant.option1, currentVariant.option2, currentVariant.option3][i];
    }

    var images = product.images && product.images.length ? product.images : product.featured_image ? [product.featured_image] : [];
    var mainImage = images[0] || '';

    var descText = stripHtml(product.description);
    var shortDesc = truncate(descText, 220);
    var material = extractSentence(descText, /Composici[oó]n[^.]*\./i);
    var sizeGuide = extractSentence(descText, /[Ll]a modelo mide[^.]*\./i) || extractSentence(descText, /modelo mide[^.]*\./i);

    var pillsHtml = '';
    for (var oi = 0; oi < optionCount; oi++) {
      pillsHtml += buildOptionPills(product, oi);
    }

    var html = '';
    html += '<div class="qvb-grid">';

    html += '  <div class="qvb-media">';
    html += '    <div class="qvb-main-image"><img id="QuickViewMainImage" src="' + escapeHtml(imgUrl(mainImage, 800)) + '" alt="' + escapeHtml(product.title) + '"></div>';
    html += buildThumbs(images);
    html += '  </div>';

    html += '  <div class="qvb-info">';
    html += '    <h2 class="qvb-title">' + escapeHtml(product.title) + '</h2>';
    html += '    <div class="qvb-price" id="QuickViewPrice"></div>';

    if (shortDesc) {
      html += '    <div class="qvb-desc">' + escapeHtml(shortDesc) + '</div>';
    }
    if (material) {
      html += '    <div class="qvb-meta-line"><strong>' + t('composition', 'Composición') + ':</strong> ' + escapeHtml(material) + '</div>';
    }
    if (sizeGuide) {
      html += '    <div class="qvb-meta-line qvb-size-guide">' + escapeHtml(sizeGuide) + '</div>';
    }

    html += '    <div class="qvb-options">' + pillsHtml + '</div>';

    html += '    <div class="qvb-qty-row">';
    html += '      <span class="qvb-qty-label">' + t('quantity', 'Cantidad') + '</span>';
    html += '      <div class="qvb-qty-stepper">';
    html += '        <button type="button" class="qvb-qty-btn" data-qty-decrease aria-label="' + t('decrease', 'Reducir cantidad') + '">−</button>';
    html += '        <input type="text" inputmode="numeric" class="qvb-qty-input" id="QuickViewQty" value="1" aria-label="' + t('quantity', 'Cantidad') + '">';
    html += '        <button type="button" class="qvb-qty-btn" data-qty-increase aria-label="' + t('increase', 'Aumentar cantidad') + '">+</button>';
    html += '      </div>';
    html += '    </div>';

    html += '    <div class="qvb-availability" id="QuickViewAvailability"></div>';

    html += '    <div class="qvb-actions">';
    html += '      <button type="button" class="qvb-btn qvb-btn--primary" id="QuickViewAddToCart">' + t('add_to_cart', 'Añadir al carrito') + '</button>';
    html += '      <button type="button" class="qvb-btn qvb-btn--secondary" id="QuickViewBuyNow">' + t('buy_now', 'Comprar ahora') + '</button>';
    html += '    </div>';

    html += '    <a class="qvb-goto-product" href="' + escapeHtml(product.url) + '">' + t('go_to_product', 'Ir al producto') + ' →</a>';
    html += '  </div>';
    html += '</div>';

    ensureRefs();
    bodyEl.innerHTML = html;

    updateVariantUI();
    bindQuickViewEvents();
  }

  function updateVariantUI() {
    ensureRefs();
    if (!bodyEl || !currentProduct) return;

    currentVariant = findMatchingVariant(currentProduct, currentSelections) || currentVariant;

    var priceEl = bodyEl.querySelector('#QuickViewPrice');
    if (priceEl && currentVariant) {
      var priceHtml = formatMoney(currentVariant.price);
      if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
        priceHtml =
          '<span class="qvb-price--original">' + formatMoney(currentVariant.compare_at_price) + '</span> ' + '<span class="qvb-price--sale">' + formatMoney(currentVariant.price) + '</span>';
      }
      priceEl.innerHTML = priceHtml;
    }

    if (currentVariant && currentVariant.featured_image) {
      var mainImgEl = bodyEl.querySelector('#QuickViewMainImage');
      if (mainImgEl) mainImgEl.src = imgUrl(currentVariant.featured_image.src || currentVariant.featured_image, 800);
    }

    var pills = bodyEl.querySelectorAll('.qvb-pill');
    pills.forEach(function (pill) {
      var idx = parseInt(pill.getAttribute('data-option-index'), 10);
      var val = pill.getAttribute('data-value');
      pill.classList.toggle('is-selected', currentSelections[idx] === val);
    });

    var availabilityEl = bodyEl.querySelector('#QuickViewAvailability');
    var addBtn = bodyEl.querySelector('#QuickViewAddToCart');
    var buyBtn = bodyEl.querySelector('#QuickViewBuyNow');
    var available = currentVariant && currentVariant.available;

    if (availabilityEl) {
      availabilityEl.textContent = available ? '' : t('sold_out', 'Agotado');
      availabilityEl.classList.toggle('is-sold-out', !available);
    }
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? t('add_to_cart', 'Añadir al carrito') : t('sold_out', 'Agotado');
    }
    if (buyBtn) {
      buyBtn.disabled = !available;
    }
  }

  function bindQuickViewEvents() {
    ensureRefs();
    if (!bodyEl) return;

    bodyEl.querySelectorAll('.qvb-pill:not(.qvb-pill--disabled)').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(pill.getAttribute('data-option-index'), 10);
        currentSelections[idx] = pill.getAttribute('data-value');
        updateVariantUI();
      });
    });

    bodyEl.querySelectorAll('.qvb-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var mainImgEl = bodyEl.querySelector('#QuickViewMainImage');
        if (mainImgEl && full) mainImgEl.src = full;
        bodyEl.querySelectorAll('.qvb-thumb').forEach(function (b) {
          b.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });

    var qtyInput = bodyEl.querySelector('#QuickViewQty');
    var decreaseBtn = bodyEl.querySelector('[data-qty-decrease]');
    var increaseBtn = bodyEl.querySelector('[data-qty-increase]');

    function setQty(value) {
      value = Math.max(1, parseInt(value, 10) || 1);
      currentQty = value;
      if (qtyInput) qtyInput.value = value;
    }

    if (decreaseBtn) decreaseBtn.addEventListener('click', function () { setQty(currentQty - 1); });
    if (increaseBtn) increaseBtn.addEventListener('click', function () { setQty(currentQty + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    var addBtn = bodyEl.querySelector('#QuickViewAddToCart');
    var buyBtn = bodyEl.querySelector('#QuickViewBuyNow');

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!currentVariant || !currentVariant.available) return;
        addToCart(currentVariant.id, currentQty, { closeAfter: true, notify: true });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (!currentVariant || !currentVariant.available) return;
        buyNow(currentVariant.id, currentQty);
      });
    }
  }

  function updateCartBubble(itemCount) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.toggle('cart-link__bubble--visible', itemCount > 0);
    });
  }

  function tryOpenNativeCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;
    var trigger = document.querySelector('.js-drawer-open-cart');
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  function addToCart(variantId, quantity, opts) {
    opts = opts || {};
    var addBtn = bodyEl ? bodyEl.querySelector('#QuickViewAddToCart') : null;
    if (addBtn) addBtn.classList.add('is-loading');

    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return fetch((routes.cart && routes.cart) || '/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartBubble(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('quick-buy:added', { detail: { cart: cart } }));

        if (opts.notify) showToast(t('added_to_cart', 'Producto añadido al carrito'));
        if (opts.closeAfter) closeModal();

        setTimeout(tryOpenNativeCartDrawer, 50);

        return cart;
      })
      .catch(function (err) {
        console.error('[QuickBuy] Error al añadir al carrito', err);
        showToast((err && err.description) || t('add_error', 'No se pudo añadir el producto. Intenta de nuevo.'));
      })
      .finally(function () {
        if (addBtn) addBtn.classList.remove('is-loading');
      });
  }

  function buyNow(variantId, quantity) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.style.display = 'none';

    function addField(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    addField('id', variantId);
    addField('quantity', quantity);
    addField('return_to', '/checkout');

    document.body.appendChild(form);
    form.submit();
  }

  function openQuickView(handle) {
    ensureRefs();
    if (!modalEl) return;
    bodyEl.innerHTML = '<div class="qvb-loading">' + t('loading', 'Cargando…') + '</div>';
    openModal();
    fetchProduct(handle)
      .then(renderQuickView)
      .catch(function (err) {
        console.error('[QuickView] Error al cargar el producto', err);
        bodyEl.innerHTML = '<div class="qvb-loading">' + t('load_error', 'No se pudo cargar el producto.') + '</div>';
      });
  }

  function handleQuickBuyClick(trigger) {
    var handle = trigger.getAttribute('data-handle');
    var variantCount = parseInt(trigger.getAttribute('data-variant-count'), 10) || 1;
    var defaultVariantId = trigger.getAttribute('data-variant-id');

    if (variantCount > 1) {
      openQuickView(handle);
      return;
    }

    if (!defaultVariantId) return;
    trigger.classList.add('is-loading');
    addToCart(parseInt(defaultVariantId, 10), 1, { notify: true }).finally(function () {
      trigger.classList.remove('is-loading');
    });
  }

  document.addEventListener('click', function (e) {
    var viewTrigger = e.target.closest('[data-quick-view]');
    if (viewTrigger) {
      e.preventDefault();
      var handle = viewTrigger.getAttribute('data-handle');
      if (handle) openQuickView(handle);
      return;
    }

    var buyTrigger = e.target.closest('[data-quick-buy]');
    if (buyTrigger) {
      e.preventDefault();
      handleQuickBuyClick(buyTrigger);
      return;
    }

    if (e.target.closest('[data-qvb-close]')) {
      e.preventDefault();
      closeModal();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
